export enum MedicalTeamTypeEnum {
  FIRST_SURGEON = 'FIRST_SURGEON',
  SECOND_SURGEON = 'SECOND_SURGEON',
  ASSISTANT = 'ASSISTANT',
  INSTRUMENTALIST = 'INSTRUMENTALIST'
}
